import { createContext, useContext, useState } from "react";

const PurchaseOrderContext = createContext();

export function PurchaseOrderProvider({ children }) {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [notifications, setNotifications] = useState([]);

  const createPO = ({ vendor, items, total }) => {
    const po = {
      id: "PO-" + Math.floor(100000 + Math.random() * 900000),
      vendor,
      items: items.map((i) => ({
        ...i,
        receivedQty: 0,
      })),
      total,
      status: "Sent to Vendors",
      date: new Date().toISOString().split("T")[0],
    };

    setPurchaseOrders((prev) => [po, ...prev]);

    setNotifications((prev) => [
      {
        id: Date.now(),
        text: `PO ${po.id} sent to vendors`,
        type: "info",
      },
      ...prev,
    ]);

    return po;
  };

  const receiveInwardFromPO = (poId, itemName, qty) => {
    setPurchaseOrders((prev) =>
      prev.map((po) => {
        if (po.id !== poId) return po;

        const updatedItems = po.items.map((item) => {
          if (item.name === itemName) {
            return {
              ...item,
              receivedQty: item.receivedQty + Number(qty),
            };
          }
          return item;
        });

        const allReceived = updatedItems.every(
          (i) => Number(i.receivedQty) >= Number(i.qty)
        );

        return {
          ...po,
          items: updatedItems,
          status: allReceived ? "Completed" : "Partially Received",
        };
      })
    );
  };

  return (
    <PurchaseOrderContext.Provider
      value={{
        purchaseOrders,
        notifications,
        createPO,
        receiveInwardFromPO,
      }}
    >
      {children}
    </PurchaseOrderContext.Provider>
  );
}

export const usePurchaseOrders = () => useContext(PurchaseOrderContext);
